import React from "react";

const ListItem = ({ itemname, theme }) => {
  return (
    <div
      className={`${
        theme === "dark"
          ? " from-white via-blue-700 to-blue-700 hover:text-darkTextColor"
          : "from-darkBgColor via-lightTextDesignColor to-lightTextDesignColor hover:text-black"
      } w-16 h-8 flex items-center justify-center hover:cursor-pointer relative overflow-hidden group bg-clip-text text-transparent bg-gradient-to-r duration-500`}
    >
      {itemname}
      <span
        className={`${
          theme === "dark" ? " bg-blue-700" : "bg-lightTextDesignColor"
        } absolute w-full h-[2px] block bottom-0 rounded-md -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-500 hover:cursor-pointer`}
      ></span>
    </div>
  );
};

export default ListItem;
